import { createContext, MouseEvent } from 'react'
import { TeamMemberStatus } from 'src/constants/team/team-members/enums'
import { TeamMember } from 'src/interfaces/team'

export interface ITeamMembersTableContext {
  refreshTeamMembers(): void

  statusFilter: Array<TeamMemberStatus>
  setStatusFilter(statusFilter: Array<TeamMemberStatus>): void

  actionAnchor: null | HTMLElement
  teamMemberToAction: TeamMember | null
  openTeamMemberItemAction(event: MouseEvent<HTMLButtonElement>, teamMember: TeamMember): void
  closeTeamMemberItemAction(): void
  clearTeamMemberToAction(): void
}

export const TeamMembersTableContext = createContext<ITeamMembersTableContext>({
  refreshTeamMembers: () => {},

  statusFilter: [],
  setStatusFilter: () => {},

  actionAnchor: null,
  teamMemberToAction: null,
  openTeamMemberItemAction: () => {},
  closeTeamMemberItemAction: () => {},
  clearTeamMemberToAction: () => {},
})
